import React, { useEffect } from 'react';
import './convocatorias.css';
import convocatorias from '../../json/convocatoriasitem';

const Convocatorias = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

    const cards = document.querySelectorAll('.card');
    cards.forEach((card, index) => {
      setTimeout(() => {
        card.classList.add('card-loaded');
      }, index * 100);
    });
  }, []);

  return (
    <div className='container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Convocatorias</h3>
          <hr className='hr-gob' />
        </div>
      </div>

      <div className='row'>

        {convocatorias.map((item, index) => (
          <div className='col-md-6 col-lg-4' key={index}>
            <div className='card'>

              <h4>{item.titulo}</h4>

              <a
                href={item.url}
                target='_blank'
                rel='noopener noreferrer'
                className='card-title'
              >
                Convocatoria
              </a>

              {/* 🔥 SOLO FORMATOS */}
              {item.anexos && (
                <>
                  <h5>Formatos</h5>
                  <ol>
                    {item.anexos.map((anexo, i) => (
                      <li key={i}>
                        <a
                          href={anexo.url}
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          {anexo.nombre}
                        </a>
                      </li>
                    ))}
                  </ol>
                </>
              )}

            </div>
          </div>
        ))}

      </div>
    </div>
  );
};

export default Convocatorias;